export enum FlightPlanFlow {
    EDIT = "edit",
    SUBMIT = "submit",
}
